import { c as _c } from "react/compiler-runtime";
import { AdvancedFilter } from '@morpho-org/ui-v6/client';
import { xor } from 'lodash-es';
import { useCallback, useMemo } from 'react';
import { trackFilterChanged } from '@/lib/analytics/client/trackers/filter';
interface TransactionTypeFilterProps {
  selectedTypes: string[];
  onFilterChange: (selectedTypes: string[]) => void;
  options: {
    label: string;
    value: string;
  }[];
  disabled?: boolean;
  side?: 'bottom' | 'left' | 'right' | 'top';
  align?: 'start' | 'center' | 'end';
  page?: string;
}

/**
 * Transaction-type filter shared by every vault and market activity table —
 * each call site passes its own `options` (the vault / market transaction
 * types) and reports usage to PostHog through `page`.
 */
export const TransactionTypeFilter = t0 => {
  const $ = _c(19);
  const {
    selectedTypes,
    onFilterChange,
    options,
    disabled: t1,
    side,
    align,
    page
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onFilterChange || $[1] !== page || $[2] !== selectedTypes) {
    t2 = transactionType => {
      const updatedTypes = xor(selectedTypes, [transactionType]);
      onFilterChange(updatedTypes);
      if (page) {
        trackFilterChanged({
          filterName: "transaction_type",
          filterValue: updatedTypes,
          page
        });
      }
    };
    $[0] = onFilterChange;
    $[1] = page;
    $[2] = selectedTypes;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggleTransactionType = t2;
  let t3;
  if ($[4] !== options || $[5] !== selectedTypes) {
    let t4;
    if ($[7] !== selectedTypes) {
      t4 = option => ({
        id: option.value,
        label: option.label,
        value: option.value,
        isChecked: selectedTypes.includes(option.value)
      });
      $[7] = selectedTypes;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = options.map(t4);
    $[4] = options;
    $[5] = selectedTypes;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const filterItems = t3;
  let t4;
  if ($[9] !== onFilterChange || $[10] !== page) {
    t4 = () => {
      onFilterChange([]);
      if (page) {
        trackFilterChanged({
          filterName: "transaction_type",
          filterValue: [],
          page
        });
      }
    };
    $[9] = onFilterChange;
    $[10] = page;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== align || $[13] !== disabled || $[14] !== filterItems || $[15] !== side || $[16] !== t4 || $[17] !== toggleTransactionType) {
    t5 = <AdvancedFilter items={filterItems} toggleItem={toggleTransactionType} clear={t4} inputPlaceholder="Search for transaction type" clearTooltipText="Remove transaction type filter." disabled={disabled} side={side} align={align} />;
    $[12] = align;
    $[13] = disabled;
    $[14] = filterItems;
    $[15] = side;
    $[16] = t4;
    $[17] = toggleTransactionType;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};